(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["halloween-grid"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('halloween-grid')) return;

    function hexToRgb(hex) {
      var h = String(hex || '').replace('#', '');
      if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
      var n = parseInt(h, 16);
      if (isNaN(n)) return [170, 80, 255];
      return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
    }

    function rand(a, b) {
      return a + Math.random() * (b - a);
    }

    function makeGhostSprite(size) {
      var c = document.createElement('canvas');
      var pad = size * 0.35;
      var w = size;
      var h = size * 1.9;
      c.width = size + pad * 2;
      c.height = h + pad * 2;
      var g = c.getContext('2d');
      g.translate(pad, pad);
      var k;
      var jag = function () { return (Math.random() - 0.5) * w * 0.1; };

      g.filter = 'blur(' + Math.max(1, Math.round(size * 0.05)) + 'px)';
      var body = g.createLinearGradient(0, 0, 0, h);
      body.addColorStop(0, 'rgba(255,255,255,0.62)');
      body.addColorStop(0.45, 'rgba(228,216,255,0.3)');
      body.addColorStop(1, 'rgba(210,190,255,0)');
      g.fillStyle = body;
      g.beginPath();
      g.moveTo(w * 0.5, 0);
      g.bezierCurveTo(w * 0.78, 0, w * 0.86, h * 0.1, w * 0.84, h * 0.2);
      g.bezierCurveTo(w * 0.96, h * 0.34, w * 0.9, h * 0.52, w * 0.98, h * 0.7);
      for (k = 0; k < 5; k++) {
        g.quadraticCurveTo(w * (0.9 - k * 0.14) + jag(), h * (0.78 + (k % 2) * 0.12), w * (0.8 - k * 0.15), h * (0.9 + (k % 2) * 0.1));
      }
      g.quadraticCurveTo(w * 0.1, h * 0.7, w * 0.02, h * 0.62);
      g.bezierCurveTo(w * 0.1, h * 0.5, w * 0.04, h * 0.34, w * 0.16, h * 0.2);
      g.bezierCurveTo(w * 0.14, h * 0.1, w * 0.22, 0, w * 0.5, 0);
      g.closePath();
      g.fill();

      g.lineCap = 'round';
      for (k = 0; k < 6; k++) {
        var sx = w * (0.12 + k * 0.15);
        g.strokeStyle = 'rgba(240,232,255,' + (0.1 + Math.random() * 0.12) + ')';
        g.lineWidth = Math.max(1, size * (0.025 + Math.random() * 0.03));
        g.beginPath();
        g.moveTo(sx, h * 0.42);
        g.bezierCurveTo(sx + jag() * 3, h * 0.6, sx - jag() * 3, h * 0.78, sx + jag() * 2, h * (0.9 + Math.random() * 0.1));
        g.stroke();
      }

      g.filter = 'blur(' + Math.max(1, Math.round(size * 0.035)) + 'px)';
      g.fillStyle = 'rgba(6,2,14,0.78)';
      g.beginPath();
      g.ellipse(w * 0.5, h * 0.19, w * 0.12, h * 0.1, 0, 0, Math.PI * 2);
      g.fill();
      g.fillStyle = 'rgba(205,225,255,0.85)';
      g.beginPath();
      g.ellipse(w * 0.46, h * 0.175, w * 0.014, h * 0.02, 0, 0, Math.PI * 2);
      g.ellipse(w * 0.54, h * 0.175, w * 0.014, h * 0.02, 0, 0, Math.PI * 2);
      g.fill();
      return { canvas: c, pad: pad, w: w, h: h };
    }

    function drawBat(ctx, x, y, s, flap, alpha) {
      var f = Math.sin(flap);
      ctx.save();
      ctx.translate(x, y);
      ctx.scale(s, s);
      ctx.globalAlpha = alpha;
      ctx.fillStyle = '#05020a';
      ctx.beginPath();
      ctx.moveTo(0, -2);
      ctx.quadraticCurveTo(-6, -8 - f * 10, -14, -4 - f * 14);
      ctx.quadraticCurveTo(-11, -1 - f * 6, -12, 3 - f * 4);
      ctx.quadraticCurveTo(-8, 0, -6, 4);
      ctx.quadraticCurveTo(-3, 1, 0, 5);
      ctx.quadraticCurveTo(3, 1, 6, 4);
      ctx.quadraticCurveTo(8, 0, 12, 3 - f * 4);
      ctx.quadraticCurveTo(11, -1 - f * 6, 14, -4 - f * 14);
      ctx.quadraticCurveTo(6, -8 - f * 10, 0, -2);
      ctx.fill();
      ctx.restore();
    }

    class HalloweenGrid extends HTMLElement {
      initHoverVideos() {
        const plates = [...this.querySelectorAll('.hg__plate[data-hg-video]')];
        if (!plates.length) return;
        const state = new Map();

        const show = (plate) => {
          const media = plate.querySelector('.m-product-card__media');
          if (!media) return;
          let st = state.get(plate);
          if (!st) {
            const video = document.createElement('video');
            video.className = 'hg__hv';
            video.src = plate.getAttribute('data-hg-video');
            video.muted = true;
            video.loop = true;
            video.playsInline = true;
            video.setAttribute('playsinline', '');
            video.preload = 'auto';
            plate.appendChild(video);
            st = { video };
            state.set(plate, st);
          }
          const video = st.video;
          const pr = plate.getBoundingClientRect();
          const mr = media.getBoundingClientRect();
          video.style.top = (mr.top - pr.top) + 'px';
          video.style.left = (mr.left - pr.left) + 'px';
          video.style.width = mr.width + 'px';
          video.style.minHeight = mr.height + 'px';
          video.style.borderRadius = getComputedStyle(media).borderRadius;
          const act = plate.querySelector('.m-product-card__action-wrapper');
          if (act) video.style.maxHeight = (act.getBoundingClientRect().bottom - mr.top) + 'px';
          const pl = video.play();
          if (pl && pl.catch) pl.catch(() => {});
          video.classList.add('is-on');
        };

        const hide = (plate) => {
          const st = state.get(plate);
          if (!st) return;
          st.video.classList.remove('is-on');
          st.video.pause();
          st.video.currentTime = 0;
        };

        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          plates.forEach((plate) => {
            plate.addEventListener('pointerenter', (e) => {
              if (e.pointerType && e.pointerType !== 'mouse') return;
              show(plate);
            });
            plate.addEventListener('pointerleave', () => hide(plate));
          });
          return;
        }

        // Touch: the first tap anywhere on a card selects it and plays its video,
        // the second tap on the same card opens the product.
        const CONTROLS = 'button, input, select, textarea, [class*="swatch"], .m-add-to-cart';
        let active = null;
        this.addEventListener('click', (e) => {
          const plate = e.target.closest('.hg__plate[data-hg-video]');
          if (!plate) {
            if (active) {
              hide(active);
              active = null;
            }
            return;
          }
          if (e.target.closest(CONTROLS) || plate === active) return;
          e.preventDefault();
          e.stopPropagation();
          if (active) hide(active);
          active = plate;
          show(plate);
        }, true);
        document.addEventListener('click', (e) => {
          if (active && !this.contains(e.target)) {
            hide(active);
            active = null;
          }
        });
      }

      connectedCallback() {
        this.canvas = this.querySelector('.hg__canvas');
        this.initHoverVideos();
        if (!this.canvas) return;
        this.ctx = this.canvas.getContext('2d');
        this.fx = this.querySelector('.hg__fx');
        this.fctx = this.fx ? this.fx.getContext('2d') : this.ctx;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.isTouch = window.matchMedia('(hover: none)').matches;
        this.accent = hexToRgb(this.dataset.accent);
        this.emberRgb = hexToRgb(this.dataset.ember);
        this.ghostCount = parseInt(this.dataset.ghosts || '0', 10);
        this.useBats = this.dataset.bats === 'true';
        this.useEmbers = this.dataset.embers === 'true';
        this.useLantern = this.dataset.lantern === 'true' && !this.isTouch;
        this.pointer = { x: -9999, y: -9999, active: false };
        this.ghosts = [];
        this.embers = [];
        this.sparks = [];
        this.fog = [];
        this.bats = [];
        this.nextFlock = performance.now() + 2500;
        this.visible = true;
        this.running = false;

        this.onResize = this.resize.bind(this);
        this.onMove = this.handleMove.bind(this);
        this.onLeave = this.handleLeave.bind(this);
        this.onClick = this.handleClick.bind(this);
        this.loop = this.frame.bind(this);

        this.resize();
        this.seed();

        this.ro = new ResizeObserver(this.onResize);
        this.ro.observe(this);
        this.addEventListener('pointermove', this.onMove);
        this.addEventListener('pointerleave', this.onLeave);
        this.addEventListener('click', this.onClick);

        this.io = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.start();
        });
        this.io.observe(this);

        if (this.reduced) {
          this.render(performance.now(), 0);
        } else {
          this.start();
        }
      }

      disconnectedCallback() {
        this.running = false;
        if (this.ro) this.ro.disconnect();
        if (this.io) this.io.disconnect();
        this.removeEventListener('pointermove', this.onMove);
        this.removeEventListener('pointerleave', this.onLeave);
        this.removeEventListener('click', this.onClick);
      }

      resize() {
        var rect = this.getBoundingClientRect();
        this.dpr = Math.min(window.devicePixelRatio || 1, 2);
        this.w = Math.max(1, rect.width);
        this.h = Math.max(1, rect.height);
        this.canvas.width = Math.round(this.w * this.dpr);
        this.canvas.height = Math.round(this.h * this.dpr);
        this.ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
        if (this.fx) {
          this.fx.width = this.canvas.width;
          this.fx.height = this.canvas.height;
          this.fctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
        }
        this.mobile = this.w < 750;
      }

      seed() {
        var i;
        for (i = 0; i < 6; i++) {
          this.fog.push({
            x: rand(0, 1), y: rand(0.1, 1), r: rand(0.25, 0.5),
            sx: rand(-0.008, 0.008), sy: rand(-0.004, 0.004), a: rand(0.05, 0.1)
          });
        }
        var emberCount = this.useEmbers ? (this.mobile ? 26 : 60) : 0;
        for (i = 0; i < emberCount; i++) this.embers.push(this.newEmber(true));
        var gc = this.mobile ? Math.min(this.ghostCount, 3) : this.ghostCount;
        for (i = 0; i < gc; i++) this.ghosts.push(this.newGhost(true));
      }

      newEmber(anywhere) {
        var warm = Math.random() < 0.65;
        return {
          x: rand(0, this.w),
          y: anywhere ? rand(0, this.h) : this.h + 10,
          vx: rand(-0.15, 0.15),
          vy: rand(-0.5, -0.15),
          r: rand(0.6, 1.8),
          life: rand(0, Math.PI * 2),
          rgb: warm ? this.emberRgb : this.accent
        };
      }

      newGhost(anywhere) {
        var size = this.mobile ? rand(34, 52) : rand(46, 86);
        return {
          sprite: makeGhostSprite(size),
          x: rand(0.04, 0.96) * this.w,
          y: anywhere ? rand(0.15, 0.95) * this.h : this.h + size * 2,
          vx: rand(-0.35, 0.35),
          vy: rand(-0.22, -0.08),
          phase: rand(0, Math.PI * 2),
          alpha: 0,
          target: rand(0.32, 0.55),
          size: size,
          scared: 0,
          dying: false
        };
      }

      spawnFlock(now) {
        var dir = Math.random() < 0.5 ? 1 : -1;
        var n = this.mobile ? 2 : Math.round(rand(3, 5));
        var y0 = rand(0.06, 0.28) * this.h;
        for (var i = 0; i < n; i++) {
          this.bats.push({
            x: dir === 1 ? -40 - i * rand(30, 60) : this.w + 40 + i * rand(30, 60),
            y: y0 + rand(-40, 40),
            vx: dir * rand(2.2, 3.4),
            amp: rand(6, 16),
            phase: rand(0, Math.PI * 2),
            flap: rand(0, Math.PI * 2),
            s: rand(0.7, 1.25)
          });
        }
        this.nextFlock = now + rand(9000, 16000);
      }

      handleMove(e) {
        var rect = this.getBoundingClientRect();
        this.pointer.x = e.clientX - rect.left;
        this.pointer.y = e.clientY - rect.top;
        this.pointer.active = true;
      }

      handleLeave() {
        this.pointer.active = false;
        this.pointer.x = -9999;
        this.pointer.y = -9999;
      }

      handleClick(e) {
        if (e.target.closest('.hg__plate, a, button, input, label, select')) return;
        var rect = this.getBoundingClientRect();
        var px = e.clientX - rect.left;
        var py = e.clientY - rect.top;
        for (var i = 0; i < this.ghosts.length; i++) {
          var g = this.ghosts[i];
          var cx = g.x + g.size / 2;
          var cy = g.y + g.size * 0.7;
          if (Math.abs(px - cx) < g.size * 0.75 && Math.abs(py - cy) < g.size) {
            g.dying = true;
            this.burst(cx, cy, 26);
            return;
          }
        }
        this.burst(px, py, 10);
      }

      burst(x, y, n) {
        for (var i = 0; i < n; i++) {
          var a = (i / n) * Math.PI * 2 + rand(-0.2, 0.2);
          var sp = rand(0.8, 2.6);
          this.sparks.push({
            x: x, y: y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 0.4,
            life: 1, r: rand(0.8, 2), rgb: Math.random() < 0.5 ? this.accent : [255, 255, 255]
          });
        }
      }

      start() {
        if (this.running || this.reduced) return;
        this.running = true;
        this.last = performance.now();
        requestAnimationFrame(this.loop);
      }

      frame(now) {
        if (!this.running) return;
        if (!this.visible) {
          this.running = false;
          return;
        }
        var dt = Math.min(3, (now - this.last) / 16.67);
        this.last = now;
        this.render(now, dt);
        requestAnimationFrame(this.loop);
      }

      render(now, dt) {
        var ctx = this.ctx;
        var w = this.w;
        var h = this.h;
        var t = now / 1000;
        var i;
        ctx.clearRect(0, 0, w, h);
        var fctx = this.fctx;
        if (this.fx) fctx.clearRect(0, 0, w, h);


        ctx.globalCompositeOperation = 'lighter';
        for (i = 0; i < this.fog.length; i++) {
          var f = this.fog[i];
          f.x += f.sx * dt * 0.1;
          f.y += f.sy * dt * 0.1;
          if (f.x < -0.3) f.x = 1.3;
          if (f.x > 1.3) f.x = -0.3;
          if (f.y < -0.2) f.y = 1.2;
          if (f.y > 1.2) f.y = -0.2;
          var fx = f.x * w;
          var fy = f.y * h;
          var fr = f.r * Math.max(w, 600);
          var fg = ctx.createRadialGradient(fx, fy, 0, fx, fy, fr);
          fg.addColorStop(0, 'rgba(' + this.accent.join(',') + ',' + f.a + ')');
          fg.addColorStop(1, 'rgba(' + this.accent.join(',') + ',0)');
          ctx.fillStyle = fg;
          ctx.fillRect(fx - fr, fy - fr, fr * 2, fr * 2);
        }

        if (this.useLantern && this.pointer.active) {
          var lr = 260;
          var lg = ctx.createRadialGradient(this.pointer.x, this.pointer.y, 0, this.pointer.x, this.pointer.y, lr);
          lg.addColorStop(0, 'rgba(' + this.accent.join(',') + ',0.22)');
          lg.addColorStop(0.5, 'rgba(' + this.accent.join(',') + ',0.06)');
          lg.addColorStop(1, 'rgba(' + this.accent.join(',') + ',0)');
          ctx.fillStyle = lg;
          ctx.fillRect(this.pointer.x - lr, this.pointer.y - lr, lr * 2, lr * 2);
        }

        for (i = 0; i < this.embers.length; i++) {
          var e = this.embers[i];
          e.life += 0.05 * dt;
          e.x += (e.vx + Math.sin(e.life * 0.7) * 0.15) * dt;
          e.y += e.vy * dt;
          if (this.pointer.active) {
            var edx = e.x - this.pointer.x;
            var edy = e.y - this.pointer.y;
            var ed = edx * edx + edy * edy;
            if (ed < 14400) {
              var ef = (1 - Math.sqrt(ed) / 120) * 0.9;
              e.x += (edx / (Math.sqrt(ed) + 0.01)) * ef * dt;
              e.y += (edy / (Math.sqrt(ed) + 0.01)) * ef * dt;
            }
          }
          if (e.y < -10 || e.x < -20 || e.x > w + 20) this.embers[i] = this.newEmber(false);
          var ea = 0.35 + Math.sin(e.life * 3) * 0.3;
          ctx.fillStyle = 'rgba(' + e.rgb.join(',') + ',' + Math.max(0, ea) + ')';
          ctx.beginPath();
          ctx.arc(e.x, e.y, e.r, 0, Math.PI * 2);
          ctx.fill();
        }

        for (i = this.sparks.length - 1; i >= 0; i--) {
          var s = this.sparks[i];
          s.x += s.vx * dt;
          s.y += s.vy * dt;
          s.vy += 0.02 * dt;
          s.life -= 0.022 * dt;
          if (s.life <= 0) {
            this.sparks.splice(i, 1);
            continue;
          }
          ctx.fillStyle = 'rgba(' + s.rgb.join(',') + ',' + s.life + ')';
          ctx.beginPath();
          ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
          ctx.fill();
        }

        ctx.globalCompositeOperation = 'source-over';

        for (i = 0; i < this.ghosts.length; i++) {
          var g = this.ghosts[i];
          g.phase += 0.012 * dt;
          var cx = g.x + g.size / 2;
          var cy = g.y + g.size * 0.7;

          if (this.pointer.active && !g.dying) {
            var dx = cx - this.pointer.x;
            var dy = cy - this.pointer.y;
            var d = Math.sqrt(dx * dx + dy * dy);
            if (d < 170) {
              var force = (1 - d / 170) * 1.6;
              g.vx += (dx / (d + 0.01)) * force * 0.12 * dt;
              g.vy += (dy / (d + 0.01)) * force * 0.12 * dt;
              g.scared = Math.min(1, g.scared + 0.08 * dt);
            }
          }
          g.scared = Math.max(0, g.scared - 0.015 * dt);
          g.vx *= 0.97;
          g.vy = g.vy * 0.97 + (-0.14) * 0.03;
          g.x += (g.vx + Math.sin(g.phase) * 0.25) * dt;
          g.y += g.vy * dt;

          if (g.dying) {
            g.alpha -= 0.04 * dt;
          } else {
            g.alpha += (g.target + g.scared * 0.25 - g.alpha) * 0.02 * dt;
          }

          if (g.alpha <= 0 && g.dying) {
            this.ghosts[i] = this.newGhost(false);
            continue;
          }
          if (g.y < -g.size * 2) this.ghosts[i] = this.newGhost(false);
          if (g.x < -g.size) g.x = w;
          if (g.x > w) g.x = -g.size;

          var sw = g.sprite.canvas.width;
          var sh = g.sprite.canvas.height;
          var tilt = Math.sin(g.phase) * 0.08 + g.vx * 0.05;
          var stretch = 1 + g.scared * 0.12;
          fctx.save();
          fctx.globalAlpha = Math.max(0, Math.min(1, g.alpha));
          fctx.translate(cx, g.y);
          fctx.rotate(tilt);
          fctx.scale(1 / stretch, stretch);
          fctx.drawImage(g.sprite.canvas, -g.size / 2 - g.sprite.pad, -g.sprite.pad, sw, sh);
          fctx.restore();
        }

        if (this.useBats && !this.reduced) {
          if (now > this.nextFlock && this.bats.length === 0) this.spawnFlock(now);
          for (i = this.bats.length - 1; i >= 0; i--) {
            var b = this.bats[i];
            b.x += b.vx * dt;
            b.phase += 0.04 * dt;
            b.flap += 0.42 * dt;
            var by = b.y + Math.sin(b.phase) * b.amp;
            if (b.x < -120 || b.x > w + 120) {
              this.bats.splice(i, 1);
              continue;
            }
            drawBat(fctx, b.x, by, b.s, b.flap, 0.85);
          }
        }
      }
    }

    customElements.define('halloween-grid', HalloweenGrid);
  })();
  } catch(e) { console.error(e); }
})();

})();
